import React from 'react';

export const pageMeta = {
  "name": "Web Geolocation API",
  "link": "/javascript/web-api/geolocation"
};

export default function JavascriptWebApiGeolocation() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web Geolocation API</h2>
      <p>Route: /javascript/web-api/geolocation</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
